import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { IonSlides } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { ChangeBranchComponent } from 'src/app/components/change-branch/change-branch.component';
import { EmbedVideoComponent } from 'src/app/components/embed-video/embed-video.component';
import { ZoomImgComponent } from 'src/app/components/zoom-img/zoom-img.component';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product-mostrario',
  templateUrl: './product-mostrario.component.html',
  styleUrls: ['./product-mostrario.component.scss'],
})
export class ProductMostrarioComponent implements OnInit, OnDestroy {
  @Input() type: number = undefined;
  @Input() set availableProductBranch(value) {
    if (value !== null) {
      this.availableProductBranchValue = value;
      if (!value) {
        this.slides.lockSwipes(true);
      } else {
        this.slides.lockSwipes(false);
      }
    }
  }
  @Input() typeProduct: string = undefined;
  @Input() isSensible: boolean = false;
  @Input() inventory: any[] = [];
  @Input() set media(value) {
    if (value) {
      this.selectedImg = value[0]?.file;
      // const ogImg = document.getElementById('og-img') as HTMLElement;
      // const file = `${environment.url}/file/${this.typeProduct}/${this.selectedImg}`;
      // this.renderer.setAttribute(ogImg, 'content', file);
      this.mediaImages = value;
      this.mediaImages = this.mediaImages.filter(
        (item) => item.file !== 'null' && item.file !== 'undefined'
      );
      if (!this.mediaImages.length) {
        this.mediaImages.push(1);
      }
    }
  }
  @Output() onZoomEmitter = new EventEmitter();
  @Output() outZoomEmitter = new EventEmitter();
  @ViewChildren('rect') rect: QueryList<ElementRef<HTMLDivElement>>;
  @ViewChild('slides', { static: true }) slides: IonSlides;
  public availableProductBranchValue = true;
  public video = '/assets/icons/video.png';
  public mediaImages: any[] = [];
  public url: string = environment.url;
  public imagenes: string[] = [environment.defaultImg, environment.defaultImg];
  public selectedImg: string = environment.defaultImg;
  public slidesOpt = {
    breakpoints: {
      220: {
        slidesPerView: 2.5,
      },
      520: {
        slidesPerView: 3.5,
      },
      720: {
        slidesPerView: 4.5,
      },
      920: {
        slidesPerView: 5.5,
      },
    },
  };
  private _subscription: Subscription = new Subscription();

  constructor(
    private uiSv: UiServices,
    private renderer: Renderer2,
    public paramSv: ParamServicesService
  ) {}

  ngOnInit() {
    this._subscription.add(
      this.slides.ionSlideDidChange.subscribe(async (ev) => {
        const index = await this.slides.getActiveIndex();
        const img = this.mediaImages[index];
        this.selectedImg = img.file;
      })
    );
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  async moveTo(direction) {
    (await direction) === 'back'
      ? this.slides.slidePrev(400)
      : this.slides.slideNext(400);
  }

  async changeImg(imagen, index?) {
    const src = imagen.file;
    if (imagen.isVideo) {
      this.uiSv.showModal(EmbedVideoComponent, { video: src });
    } else {
      await this.slides.slideTo(index, 500);
      this.selectedImg = src;
    }
  }

  onZoom(ev, element, index: number) {
    if (this.type !== 1) {
      return false;
    }
    //Medidas del contenedor
    const rect = this.rect.get(index).nativeElement;
    const w1 = element.el.offsetWidth;
    const h1 = element.el.offsetHeight;
    //Posicion del mouse
    let x = ev.offsetX;
    let y = ev.offsetY;
    //Medidas del rectangulo
    let w2 = rect.offsetWidth / 2;
    let h2 = rect.offsetHeight / 2;
    let xx = x - w2;
    let yy = y - h2;
    if (x < w2) {
      x = w2;
      xx = 0;
    }

    if (y < h2) {
      y = h2;
      yy = 0;
    }

    if (x > w1 - w2) {
      x = w1 - w2;
      xx = x - w2;
    }

    if (y > h1 - h2) {
      y = h1 - h2;
      yy = y - h2;
    }
    if (document.body.offsetWidth > 769) {
      this.renderer.setStyle(rect, 'left', `${x}px`);
      this.renderer.setStyle(rect, 'top', `${y}px`);
      this.renderer.setStyle(rect, 'opacity', '1');
      this.onZoomEmitter.emit({
        ev,
        img: this.mediaImages[index].file,
        w2,
        h2,
        xx,
        yy,
      });
    }
  }

  offZoom(index) {
    if (this.type !== 1) {
      return false;
    }
    const rect = this.rect.get(index).nativeElement;
    this.renderer.setStyle(rect, 'opacity', '0');
    this.outZoomEmitter.emit();
  }

  async openImg(img) {
    if (!img?.isVideo && document.body.offsetWidth < 769) {
      const data = {
        img,
        typeProduct: this.typeProduct,
      };
      await this.uiSv.showModal(ZoomImgComponent, { data }, 'zoomContainer');
    }
  }

  async openBranch(ev: Event) {
    ev.preventDefault();
    ev.stopPropagation();
    await this.uiSv.showPopover(
      ChangeBranchComponent,
      {
        availableBranch: this.inventory,
      },
      'branch-pop'
    );
  }
}
